const fieldsFor = (data, entityOnly) => {
  const term = window.getTermOverride;
  const entity = [
    ['First Name', 'firstname'],
    ['Last Name', 'lastname'],
    ['Address Line 1', 'addressline1'],
    ['Address Line 2', 'addressline2'],
    ['City', 'city'],
    ['State', 'state'],
    ['Zip Code', 'zip_code'],
    ...(!entityOnly
      ? [
          ['Displayed Name', 'display_name'],
          ['Email', 'email'],
          ['Phone', 'phone'],
          ['Reset password link', 'reset_password_link'],
          ['Link accounts link', 'link_account_link'],
        ]
      : []),
  ];
  const lease = [
    ['Id', 'id'],
    ['Move Out Date', 'move_out_date'],
    ['Month to Month Status', 'month_to_month'],
    ['Responsibility Date', 'responsibility_date'],
    ['Security Deposit Held', 'security_deposit_held'],
    ['Security Deposit Charged', 'security_deposit_charged'],
    ...(!entityOnly
      ? [
          ['Start Date', 'start_date'],
          ['End Date', 'end_date'],
          [term('company', true) + ' Name', 'company_name'],
          ['Latest Schedule Start Date', 'latest_monthly_schedule.start_date'],
          ['Latest Schedule End Date', 'latest_monthly_schedule.end_date'],
          [
            'Latest Schedule Month to Month',
            'latest_monthly_schedule.month_to_month',
          ],
          [
            term('rent', true) + ' Amount with Increases',
            'latest_monthly_schedule_rent_amount',
          ],
          [
            'Schedule ' + term('rent', true) + ' Increase Amount',
            'latest_scheduled_increase',
          ],
        ]
      : []),
    ...data.lease_custom_fields,
  ];
  return {
    current_date: [['Current Date', '']],
    tenant: [
      ...entity,
      ['Balance', 'balance'],
      ['Past Due Balance', 'past_due_balance'],
      ...(!entityOnly
        ? [
            [
              'Primary ' + term('tenant', true) + ' Balance',
              'primary_tenant_balance',
            ],
          ]
        : []),
      [term('lease', true), 'current_lease'],
      [term('company', true) + ' Name', 'company_name'],
      ...(entityOnly
        ? [
            ['Login Button', 'person_login_button'],
            ['Login URL', 'person_login_url'],
          ]
        : []),
      ...data.tenant_custom_fields,
      ...data.person_custom_fields,
    ],
    entity,
    other_contact: entity,
    vendor: [...entity, ...data.vendor_custom_fields],
    owner: [...entity, ...data.owner_custom_fields],
    company: [...entity, ...data.company_custom_fields],
    person: [
      ...entity,
      ['Login Button', 'person_login_button'],
      ['Login URL', 'person_login_url'],
    ],
    contact: [
      ['First Name', 'firstname'],
      ['Last Name', 'lastname'],
      ['Displayed Name', 'display_name'],
      ['Budget', 'interest.budget'],
      ['Label', 'contact_label'],
      ['Site', 'site_name'],
      [term('company', true), 'company_name'],
      ...data.contact_custom_fields,
    ],
    lease,
    current_lease: lease,
    property: [
      ['Marketing Phone', 'marketing_phone'],
      ['Marketing Email', 'marketing_email'],
      ['Name', 'name'],
      ['Address', 'address'],
      ...data.building_custom_fields,
    ],
    unit: [
      ['Name', 'name'],
      ['Number', 'number'],
      ['Address', 'address'],
      ...data.unit_custom_fields,
    ],
    invoice: [
      ['Amount', 'amount'],
      ['Balance', 'balance'],
      ['Date', 'date'],
      ['Due Date', 'due_date'],
      ['Entity', 'entity'],
      ['Id', 'id'],
      ['Number', 'number'],
      [term('lease', true), 'lease'],
    ],
    invoicepayment: [
      ['Amount', 'amount'],
      ['Amount With Portal Fee', 'amount_with_portal_fee'],
      ['Portal Fee', 'portal_fee'],
      ['Date', 'date'],
      ['Deposited Status', 'deposited_status'],
      ['Entity', 'entity'],
      ['Id', 'id'],
      ['Number', 'number'],
    ],
    bill: [
      ['Amount', 'amount'],
      ['Balance', 'balance'],
      ['Date', 'date'],
      ['Description', 'description'],
      ['Due Date', 'due_date'],
      ['Entity', 'entity'],
      ['Id', 'id'],
      ['Number', 'number'],
    ],
    billpayment: [
      ['Amount', 'amount'],
      ['Date', 'date'],
      ['Deposited Status', 'deposited_status'],
      ['Entity', 'entity'],
      ['Id', 'id'],
      ['Number', 'number'],
    ],
    refund: [
      ['Amount', 'amount'],
      ['Date', 'date'],
      ['Entity', 'entity'],
      ['Id', 'id'],
      ['Number', 'number'],
    ],
    maintenance_request: [
      ['Subject', 'subject'],
      ['Request Message', 'request'],
      ['Request Date', 'request_date'],
      ['Request Category', 'request_category.name'],
      ['Status', 'status'],
      ['Number', 'number'],
      ['Site Name', 'site_name'],
      ['Address', 'site_address'],
      ['URL', 'url'],
      ['Last Note Created Value', 'last_note_created_value'],
      [
        term('tenant', true) + ' Contact Info - Phone Number',
        'tenant_phone_number',
      ],
      [
        term('tenant', true) + ' Contact Info - Email Address',
        'tenant_email_address',
      ],
      [term('tenant', true) + ' Display Name', 'tenant_display_name'],
      ...data.maintenance_custom_fields,
    ],
    property_manager: [
      ['Organization', 'organization'],
      ['Phone Number', 'phone'],
      ['Email', 'email'],
      [term('company', true) + ' Logo Small', 'company_logo'],
      [term('company', true) + ' Logo Original', 'company_logo_original'],
    ],
    email_company: [
      [term('company', true) + ' Name', 'company_name'],
      ['Phone Number', 'phone'],
      ['Email', 'email'],
    ],
    received_email: [
      ['Subject', 'subject'],
      ['Body', 'body'],
      ['Sender Email', 'sender_email'],
    ],
  };
};

export const registerEmailDatafields = () => {
  const composerEntityTypes = ['tenant', 'vendor', 'owner'];
  $.FE.POPUP_TEMPLATES['emailDatafield.insert'] = '[_CUSTOM_LAYER_]';
  $.FE.PLUGINS.emailDatafields = function (editor) {
    let popup;
    let fields;
    let token;
    let request;
    const loadAndShow = (element) => {
      if (
        editor.opts.emailDatafields !== 'template' &&
        !composerEntityTypes.includes(editor.opts.emailComposerEntityType)
      )
        return;
      token =
        element || $(editor.selection.element()).closest('email_datafield')[0];
      if (!element && token && editor.selection.isCollapsed()) {
        const { atStart, atEnd } = editor.selection.info(token);
        if (atStart || atEnd) {
          const range = editor.selection.ranges(0);
          if (atStart) range.setStartBefore(token);
          else range.setStartAfter(token);
          range.collapse(true);
          token = null;
        }
      }
      // Saving the caret adds marker text inside an existing datafield.
      const path = token ? token.textContent.slice(2, -2) : null;
      editor.selection.save();
      if (fields) {
        show(path);
        return;
      }
      if (request) request.abort();
      request = $.ajax({
        url: '/email_templates_get_custom_fields',
        data: { format: 'js' },
        dataType: 'json',
        success: (data) => {
          request = null;
          fields = fieldsFor(data, editor.opts.emailDatafields !== 'template');
          show(path);
        },
        error: (_xhr, status) => {
          if (status !== 'abort')
            errorAlert('Unable to load datafields. Please try again.');
        },
      });
    };
    const populate = (select, options) => {
      select.empty();
      options.forEach(([label, value]) =>
        select.append($('<option>').val(value).text(label))
      );
      select.closest('label').toggle(options.length > 0);
    };
    const show = (path) => {
      if (!popup) {
        popup = editor.popups.create('emailDatafield.insert', {
          custom_layer: `<div class="fr-layer fr-active pm-email-datafields" role="dialog" aria-label="Datafield Properties">
            <label>Select an entity type<select class="pm-datafield-entity" aria-label="Select an entity type"></select></label>
            <label>Select your datafield<select class="pm-datafield-field" aria-label="Select your datafield"></select></label>
            <label>Related datafield<select class="pm-datafield-related" aria-label="Related datafield"></select></label>
            <label>Related field detail<select class="pm-datafield-detail" aria-label="Related field detail"></select></label>
            <div class="fr-action-buttons"><button type="button" class="fr-command fr-submit" data-cmd="insertEmailDatafield">Insert</button></div>
          </div>`,
        });
      }
      const entity = popup.find('.pm-datafield-entity');
      const field = popup.find('.pm-datafield-field');
      const related = popup.find('.pm-datafield-related');
      const detail = popup.find('.pm-datafield-detail');
      const term = window.getTermOverride;
      const entities =
        editor.opts.emailDatafields === 'template'
          ? [
              ['Date', 'current_date'],
              [term('tenant', true), 'tenant'],
              ['Vendor', 'vendor'],
              [term('company', true), 'company'],
              [term('owner', true), 'owner'],
              ['Person', 'person'],
              ['Lead', 'contact'],
              ['Other', 'other_contact'],
              ['Property', 'property'],
              ['Unit', 'unit'],
              [term('lease', true), 'lease'],
              ['Invoice', 'invoice'],
              ['Invoice Payment', 'invoicepayment'],
              ['Bill', 'bill'],
              ['Bill Payment', 'billpayment'],
              ['Refund', 'refund'],
              ['Maintenance Request', 'maintenance_request'],
              ['Property Manager', 'property_manager'],
              ['Email ' + term('company', true), 'email_company'],
              ['Received Email', 'received_email'],
            ]
          : [
              [term('tenant', true), 'tenant'],
              ['Vendor', 'vendor'],
              [term('owner', true), 'owner'],
            ];
      populate(entity, entities);
      entity.off('change').on('change', () => {
        populate(field, fields[entity.val()]);
        field.trigger('change');
      });
      field.off('change').on('change', () => {
        populate(related, fields[field.val()] || []);
        related.trigger('change');
      });
      related
        .off('change')
        .on('change', () => populate(detail, fields[related.val()] || []));
      const composeEntity = editor.opts.emailComposerEntityType;
      if (composeEntity) entity.val(composeEntity);
      entity.closest('label').toggle(!composeEntity);
      entity.trigger('change');
      if (token && (!composeEntity || path.split('.')[0] === composeEntity)) {
        const root = path.split('.')[0];
        entity.val(root).trigger('change');
        let remaining = path.slice(root.length + 1);
        [field, related, detail].forEach((select) => {
          const match = Array.from(select[0].options)
            .map((option) => option.value)
            .filter(
              (value) =>
                remaining === value || remaining.startsWith(`${value}.`)
            )
            .sort((a, b) => b.length - a.length)[0];
          if (match !== undefined) {
            select.val(match).trigger('change');
            remaining = remaining.slice(match.length + 1);
          }
        });
      } else if (editor.opts.emailDatafields === 'template') {
        const category = $(
          '#email_template_form .email_attachment:visible .category'
        )
          .first()
          .text()
          .toLowerCase()
          .replace(' ', '');
        if (['invoice', 'invoicepayment', 'bill'].includes(category))
          entity.val(category).trigger('change');
        if (category === 'maintenancerequest')
          entity.val('maintenance_request').trigger('change');
      }
      const button = editor.$tb.find('[data-cmd="emailDatafield"]');
      editor.popups.setContainer('emailDatafield.insert', editor.$tb);
      editor.popups.show(
        'emailDatafield.insert',
        button.offset().left,
        button.offset().top + button.outerHeight(),
        button.outerHeight()
      );
    };
    return {
      _init: () => {
        if (!editor.opts.emailDatafields) return false;
        editor.events.on('initialized', () => editor.button.bulkRefresh());
        editor.events.on('emailDatafields.refresh', () => {
          if (request) {
            request.abort();
            request = null;
          }
          editor.popups.hide('emailDatafield.insert');
          editor.button.bulkRefresh();
        });
        editor.events.$on(editor.$el, 'dblclick', 'email_datafield', (event) =>
          loadAndShow(event.currentTarget)
        );
        editor.events.on('destroy', () => {
          if (request) request.abort();
        });
      },
      show: () => loadAndShow(),
      insert: () => {
        const root = popup.find('.pm-datafield-entity').val();
        const path = [
          root,
          ...popup
            .find('select')
            .not('.pm-datafield-entity')
            .filter((_index, select) =>
              $(select).closest('label').is(':visible')
            )
            .map((_index, select) => select.value)
            .get(),
        ]
          .filter((value) => value !== '')
          .join('.');
        editor.popups.hide('emailDatafield.insert');
        editor.selection.restore();
        editor.undo.saveStep();
        if (token) token.textContent = `[[${path}]]`;
        else
          editor.html.insert(
            $('<email_datafield>').text(`[[${path}]]`)[0].outerHTML
          );
        editor.undo.saveStep();
        editor.events.trigger('contentChanged');
      },
    };
  };
  $.FE.DefineIcon('emailDatafield', {
    NAME: 'Insert Datafield',
    template: 'text',
  });
  $.FE.RegisterCommand('emailDatafield', {
    title: 'Insert Datafield',
    disabled: true,
    forcedRefresh: true,
    undo: false,
    focus: false,
    popup: true,
    refresh: function (button) {
      const disabled =
        this.opts.emailDatafields !== 'template' &&
        !composerEntityTypes.includes(this.opts.emailComposerEntityType);
      button
        .toggleClass('fr-disabled', disabled)
        .attr('aria-disabled', disabled);
    },
    callback: function () {
      this.emailDatafields.show();
    },
  });
  $.FE.RegisterCommand('insertEmailDatafield', {
    title: 'Insert',
    undo: false,
    focus: false,
    callback: function () {
      this.emailDatafields.insert();
    },
  });
};
